// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"48":"920a55ab","64":"56798cb4","80":"7c353e4f","205":"f9a1cafc","694":"997baeaa","773":"41464963","850":"42a4ba8b","985":"f8867be6"}[chunkId] + ".css";
};